import baseScmService from 'services/baseScmService';

const uploadVideoService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    getUploadedVideos: build.query({
      query: ({ searchQuery, currentPage = 1, limit = 20 }) => {
        const params = {
          current_page: currentPage,
          limit,
        };
        if (searchQuery) {
          params.searchQuery = searchQuery;
        }

        return {
          method: 'GET',
          url: '/asset-management/raw-assets/search',
          params,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetUploadedVideosQuery } = uploadVideoService;

export default uploadVideoService;
